import axiosInstance from '@/shared/api/axios';
import type { ApiSupportStaffClientListResponse } from '@/shared/types/api/support-staff';

export const apiSupportStaffClientList = async (): Promise<ApiSupportStaffClientListResponse> => {
  const { data } = await axiosInstance.get<ApiSupportStaffClientListResponse>('/support-staff/client');
  return data;
};
